import { TabValue } from '@/types';

type CanNavigateToResultParams = {
  hasResult: boolean;
  isFetching: boolean;
  tab: TabValue;
};

export function canNavigateToResult({ hasResult, isFetching, tab }: CanNavigateToResultParams) {
  return hasResult && !isFetching && tab !== TabValue.result;
}
